import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Box } from '@mui/material';

import { styles } from './styles';
import AppBar from '@components/common/AppBar';
import { Modals } from '@core/Modal';
import { registeredModals } from '@components/modals/registeredModals';
import SuspenseLoading from '@components/common/SuspenseLoading';

export type HomeLayoutProps = {};

const HomeLayout: React.FC<HomeLayoutProps> = () => {
  return (
    <Box sx={styles.root}>
      <AppBar />
      <Modals registeredModals={registeredModals} />
      <Suspense fallback={<SuspenseLoading />}>
        <Outlet />
      </Suspense>
    </Box>
  );
};

export default HomeLayout;
